import { QueryClient } from '@tanstack/react-query';
import { DEFAULT_QUERY_RETRY } from './queryDefaults.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 dakika
      retry: DEFAULT_QUERY_RETRY,
      refetchOnWindowFocus: false,
    },
  },
});
